import { AfterViewInit, Component } from '@angular/core';
declare var jQuery: any;



@Component({
    selector: 'footer',
    templateUrl: 'footer.template.html'
})

export class FooterComponent implements AfterViewInit {

    ngAfterViewInit() {
        jQuery(document).ready(function () {
            jQuery('.pie').load('assets/footer.html');

        });
    }

}